import {
    GET_ORDER,
    GET_BILL,
    REMOVE_INVOICE,
    INVOICE_PAYED,
    RETRIEVE_INVOICE_LIST,
    REMOVE_INVOICE_LIST,
    START_CHECKING_FOR_COMMENT,
    END_CHECKING_FOR_COMMENT,
    RATE,
    RETRIEVED_DRIVER_DATA,
    START_SENDING_COMMENT,
    END_SENDING_COMMENT,
    CHANGE_COMMENT,
    SHOW_DELETE_ALERT,
    HIDE_DELETE_ALERT,
    REFINE_BILL,
    SET_DISCOUNT_CHANGES,
    CHANGE_PROVIDER_NAME_IN_OFFER_FEEDBACK,
    CHANGE_PRICE_OFFER_FEEDBACK,
    CHANGE_DESC_OFFER_FEEDBACK,
    SHOW_PRICE_FEEDBACK_MODAL,
    SENDING_PRICE_FEEDBACK,
    CATCH_SUBMITTING_PRICE_FEEDBACK_ERRORS,
    UPDATE_DRIVER_LOCATION,
    RATING, CHANGE_RATE
} from "../actions/actionsTypes";


// eslint-disable-next-line import/no-anonymous-default-export
export default (state = {}, action) => {
    switch (action.type) {

        case GET_ORDER:
            return {...state, oneOrder: action.payload};

        case GET_BILL:
            return {...state, bill: action.payload.data};

        case REMOVE_INVOICE:
            return {...state, bill: undefined, oneOrder: undefined};

        case INVOICE_PAYED:
            return {...state, invoicePayed: true};

        case RETRIEVE_INVOICE_LIST:
            return {...state, invoiceList: action.list, invoiceListCurrentPage: action.page}

        case REMOVE_INVOICE_LIST:
            return {...state, invoiceList: undefined, invoiceListCurrentPage: 1}

        case START_CHECKING_FOR_COMMENT:
            return {...state, checkingForComment: true}

        case END_CHECKING_FOR_COMMENT:
            return {...state, checkingForComment: false}

        case START_SENDING_COMMENT:
            return {...state, sendingComment: true}

        case END_SENDING_COMMENT:
            return {...state, sendingComment: false}

        case RATE:
            return {...state, rate: action.num}

        case RETRIEVED_DRIVER_DATA:
            return {...state, driver: action.res.data[0]}

        case CHANGE_COMMENT:
            return {...state, commentText: action.value}

        case SHOW_DELETE_ALERT:
            return {...state, deleteAlert: true, warningMessage: action.message}

        case HIDE_DELETE_ALERT:
            return {...state, deleteAlert: false}

        case REFINE_BILL:
            const {
                order: {
                    status,
                    total_price_with_discount: price,
                    total_price: before_discount_price,
                    car: {
                        driver_data,
                        detail: carDetails
                    } = {},
                    workers: {
                        detail: workerDetails
                    } = {},
                    expensive_tools: {
                        detail: expensives
                    },
                } = {},
                receiver_detail: {
                    order_id: id,
                    name,
                    receiver_name,
                    phone,
                    origin_address,
                    dest_address: destination_address,
                    timestamp: time,
                    origin_floor,
                    dest_floor: destination_floor,
                } = {}
            } = action.payload.data;

            let exps = [];
            expensives.map(item => exps.push({...item, count: item.number}));

            const bill = {
                id,
                status,
                name,
                receiver_name,
                phone,
                origin_address,
                destination_address,
                time,
                origin_floor,
                destination_floor,
                price,
                before_discount_price,
                driver: {
                    name: driver_data[1],
                    phone: driver_data[2],
                },
                details: [
                    {...carDetails[0], count: carDetails[0].number},
                    {...workerDetails[0], count: workerDetails[0].number},
                    ...exps
                ]
            }
            return {...state, bill}

        case SET_DISCOUNT_CHANGES:
            return {
                ...state, bill: {
                    ...state.bill,
                    price: action.data
                }
            };

        case CHANGE_PROVIDER_NAME_IN_OFFER_FEEDBACK:
            return {
                ...state,
                priceFeedback: {
                    ...state.priceFeedback,
                    provider: action.value
                }
            }

        case CHANGE_PRICE_OFFER_FEEDBACK:
            return {
                ...state,
                priceFeedback: {
                    ...state.priceFeedback,
                    price: action.value
                }
            }

        case CHANGE_DESC_OFFER_FEEDBACK:
            return {
                ...state,
                priceFeedback: {
                    ...state.priceFeedback,
                    description: action.value
                }
            }

        case SHOW_PRICE_FEEDBACK_MODAL:
            return {
                ...state,
                priceFeedback: {
                    ...state.priceFeedback,
                    display: action.value
                }
            }

        case SENDING_PRICE_FEEDBACK:
            return {
                ...state,
                priceFeedback: {
                    ...state.priceFeedback,
                    sending: action.value
                }
            }

        case CATCH_SUBMITTING_PRICE_FEEDBACK_ERRORS:
            return {
                ...state,
                priceFeedback: {
                    ...state.priceFeedback,
                    errors: action.value
                }
            }

        case UPDATE_DRIVER_LOCATION:
            return {...state, driverLocation: action.value}

        case RATING:
            return {...state, order: {...state.order, metraj: action.value}}

        case CHANGE_RATE:
            if (action.workerId) {
                var arr = state.bill.workers;
                state.bill.workers.map(obj => {
                    if (obj.id === action.workerId) {
                        arr = state.bill.workers.filter(object => object.id !== action.workerId);
                        arr = [...arr, {...obj, rate: action.rate}];
                    }
                });
                return {...state, bill: {...state.bill, workers: arr}}
            }

            return {...state, rate: action.rate}

        default:
            return state;
    }
}